import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';

import { setKeyboardValue } from '@williamhill/rosi-ui-shared/src/store/reducers/keyboard/keyboard.actions';
import { IStoreState } from '@williamhill/rosi-ui-shared/src/store/types';
import Keyboard from './index';

const KeyboardWrapper = styled.div`
  background: ${({ theme }) => theme.components.homePage.background};
  border-radius: 1.5rem 1.5rem 0 0;
`;

const HiddenKeyboard = styled(Keyboard)<{ isKeyboardOpen: boolean }>`
  ${({ isKeyboardOpen }) => !isKeyboardOpen && `max-height: 0;`}
`;

const ConnectedKeyboard = ({ keyboardParentRef, emailMode = false }) => {
  const [refState, setRefState] = useState<React.RefObject<HTMLDivElement> | null>(null);

  const field = useSelector(({ keyboard }: ReturnType<IStoreState>) => keyboard.field);
  const value = useSelector(({ keyboard }: ReturnType<IStoreState>) => keyboard.value[field] || '');
  const dispatch = useDispatch();
  const onChange = value => dispatch(setKeyboardValue({ value, field }));

  useEffect(() => {
    setRefState(keyboardParentRef);
  }, [keyboardParentRef]);

  if (refState?.current) {
    return ReactDOM.createPortal(
      <KeyboardWrapper>
        <HiddenKeyboard value={value} onChange={onChange} isKeyboardOpen={Boolean(field)} emailMode={emailMode} />
      </KeyboardWrapper>,
      refState.current
    );
  }
  return null;
};

export default ConnectedKeyboard;
